export const CONSENT_COOKIE = "cookie_consent";
const CONSENT_EXPIRY_DAYS = 365;

export const CONSENT_STATUSES = {
  granted: "granted",
  denied: "denied",
};

export const CONSENT_SIGNALS = ["analytics_storage", "ad_storage", "ad_user_data", "ad_personalization"];

export const REGION_DENIED_BY_DEFAULT = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "IS",
  "LI",
  "NO",
  "GB",
  "CH",
];

function getConsentPayload(status) {
  return CONSENT_SIGNALS.reduce((payload, signal) => {
    payload[signal] = status;
    return payload;
  }, {});
}

export function getConsentBootstrapScript() {
  const deniedPayload = JSON.stringify({
    ...getConsentPayload(CONSENT_STATUSES.denied),
    region: REGION_DENIED_BY_DEFAULT,
    wait_for_update: 500,
  });
  const grantedPayload = JSON.stringify(getConsentPayload(CONSENT_STATUSES.granted));
  const consentSignals = JSON.stringify(CONSENT_SIGNALS);

  return `
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

gtag("consent", "default", ${deniedPayload});
gtag("consent", "default", ${grantedPayload});

var consentCookie = document.cookie.match(/(?:^|; )${CONSENT_COOKIE}=([^;]*)/);
var consentValue = consentCookie && consentCookie[1];

if (consentValue === "${CONSENT_STATUSES.granted}" || consentValue === "${CONSENT_STATUSES.denied}") {
  var consentSignals = ${consentSignals};
  var consentUpdatePayload = {};

  consentSignals.forEach(function (signal) {
    consentUpdatePayload[signal] = consentValue;
  });

  gtag("consent", "update", consentUpdatePayload);
}
`;
}

export function getStoredConsent() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${CONSENT_COOKIE}=([^;]*)`));
  if (!match) return null;
  return match[1] === CONSENT_STATUSES.granted ? CONSENT_STATUSES.granted : CONSENT_STATUSES.denied;
}

export function setStoredConsent(status) {
  const expires = new Date();
  expires.setDate(expires.getDate() + CONSENT_EXPIRY_DAYS);
  document.cookie = `${CONSENT_COOKIE}=${status}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

export function updateGtagConsent(status) {
  window.gtag?.("consent", "update", getConsentPayload(status));
}
